import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import { Box, Stack, SxProps, Tooltip, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import RoleGuard from "components/RoleGuard";
import VidletBtnLogout from "components/VidletBtnLogout";
import ROLE from "enums/ROLE_NAME";
import useVidletNavigate from "hooks/navigation/useVidletNavigate";
import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

function BtnAdmin() {
  const { slug } = useParams();
  const { pathname } = useLocation();
  const { navigate } = useVidletNavigate();
  const url = useMemo(() => `/project/${slug}/admins`, [slug]);
  const isActive = useMemo(() => pathname.includes("admins"), [pathname]);
  return (
    <IconButton
      color={isActive ? "primary" : "inherit"}
      onClick={() => navigate(url)}
    >
      <Tooltip title="Admins" placement="bottom">
        <SupervisedUserCircleIcon />
      </Tooltip>
    </IconButton>
  );
}

interface Props {
  name?: string;
  sx?: SxProps;
}

export default function Header({ name, sx }: Props) {
  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        ...sx,
      }}
    >
      {/* empty box to offset VidletBtnLogout */}
      <Box sx={{ width: "142px" }} />
      <Stack direction="row" spacing={0.5} alignItems="center">
        {name && <Typography variant="h5">{name}</Typography>}
      </Stack>
      <Stack direction="row">
        <RoleGuard disallowedRoles={[ROLE.VIEWER]}>
          <BtnAdmin />
        </RoleGuard>
        <VidletBtnLogout />
      </Stack>
    </Stack>
  );
}
